/**
 * Post create/update Zod schemas
 */

import { z } from 'zod'
import { POST_STATUSES, CONTENT_TYPES } from '../constants/statuses'
import { LINKEDIN_LIMITS } from '../constants/limits'

export const createPostSchema = z.object({
  content: z.string().min(1).max(LINKEDIN_LIMITS.postMaxLength),
  contentType: z.enum(CONTENT_TYPES as unknown as [string, ...string[]]),
  status: z.enum(POST_STATUSES as unknown as [string, ...string[]]).default('draft'),
  topic: z.string().max(200).optional(),
  scheduledAt: z.string().datetime().optional(),
})

export const updatePostSchema = z.object({
  content: z.string().min(1).max(LINKEDIN_LIMITS.postMaxLength).optional(),
  contentType: z.enum(CONTENT_TYPES as unknown as [string, ...string[]]).optional(),
  status: z.enum(POST_STATUSES as unknown as [string, ...string[]]).optional(),
  topic: z.string().max(200).optional(),
  scheduledAt: z.string().datetime().nullable().optional(),
  likes: z.number().int().min(0).optional(),
  comments: z.number().int().min(0).optional(),
  impressions: z.number().int().min(0).optional(),
  shares: z.number().int().min(0).optional(),
})

export type CreatePostInput = z.infer<typeof createPostSchema>
export type UpdatePostInput = z.infer<typeof updatePostSchema>
